import { render, staticRenderFns } from "./EditarObservacionesModel.vue?vue&type=template&id=51c5e71e"
import script from "./EditarObservacionesModel.vue?vue&type=script&lang=js"
export * from "./EditarObservacionesModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports